import RenderData from "components/RenderData";
import React from "react";
import { ChevronRight, History } from "tabler-icons-react";

const formatDate = (value, withHour = false) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("fr", {
    day: "numeric",
    month: "long",
    year: "numeric",
    ...(withHour ? { hour: "numeric", minute: "numeric" } : {}),
  });
};

function TentativeRow({ title, date, badge, onClick }) {
  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") onClick?.();
      }}
      className="w-full bg-white rounded-2xl border border-black/[0.07] p-3 flex items-center gap-3 cursor-pointer active:scale-[0.99] transition-transform"
    >
      <div className="h-10 w-10 rounded-xl bg-secondary/10 text-secondary flex items-center justify-center shrink-0">
        <History size={19} />
      </div>

      <div className="flex-1 min-w-0">
        <p className="font-bold text-primary text-[15px] truncate">{title}</p>
        <p className="text-[12.5px] text-primary/45 mt-0.5 truncate">
          {date}
          {badge ? <span className="text-primary/30"> · </span> : null}
          {badge ? (
            <span className="font-semibold text-green-700">{badge}</span>
          ) : null}
        </p>
      </div>

      <ChevronRight size={20} className="text-primary/25 shrink-0" />
    </div>
  );
}

function EmptyHistorique() {
  return (
    <div className="bg-white rounded-2xl border border-dashed border-black/10 px-4 py-7 text-center">
      <div className="h-12 w-12 rounded-full bg-secondary/10 text-secondary flex items-center justify-center mx-auto mb-2">
        <History size={22} />
      </div>
      <p className="font-bold text-primary text-[14px]">
        Aucun diagnostic pour le moment
      </p>
      <p className="text-[12.5px] text-primary/45 mt-1">
        Lancez un premier diagnostic : les résultats s'affichent ici.
      </p>
    </div>
  );
}

function Tentative({
  eleve,
  studentDemo,
  data = [],
  isLoading,
  onClick,
  offlineData,
}) {
  const prenom = String(studentDemo?.fullName ?? "").split(" ")[0];

  return (
    <div className="px-2 pt-5 pb-2">
      <div className="mb-3">
        <h2 className="font-extrabold text-primary text-[19px] leading-tight">
          Déjà réalisé
        </h2>
        <p className="text-[13px] text-primary/50 mt-0.5">
          Historique des tentatives{prenom ? ` de ${prenom}` : ""}
        </p>
      </div>

      <div className="flex flex-col gap-2">
        {offlineData ? (
          <RenderData
            data={data}
            renderEmpty={<EmptyHistorique />}
            render={(history, index) => (
              <TentativeRow
                key={`${history?.id}-${index}`}
                title={history?.type}
                date={formatDate(history?.date_diagnostic, true)}
                onClick={() => onClick(history)}
              />
            )}
          />
        ) : (
          <RenderData
            isLoading={isLoading}
            data={data}
            renderEmpty={<EmptyHistorique />}
            render={(history, index) => (
              <TentativeRow
                key={history?.id ?? index}
                title={history?.diagnostic}
                date={formatDate(history?.last_date)}
                badge={
                  history?.count
                    ? `${history.count} tentative${history.count > 1 ? "s" : ""}`
                    : null
                }
                onClick={() => onClick(history)}
              />
            )}
          />
        )}
      </div>
    </div>
  );
}

export default Tentative;
